import React, { useRef } from "react";
import { useReduxState } from "../../../explorer/redux/hooks";
import { reduxStoreConfig } from "../../configuration/reduxStoreConfig";
import { useLocation, useMatch, useSearchParams } from "react-router-dom";
import {
    defaultBrand,
    defaultContext,
    defaultLanguage,
} from "../../configuration/defaultSettings";
import { NavigationState } from "../../../explorer/types";
import useLanguages from "../../../explorer/hooks/useLanguages";
import AuthenticationLoading from "../Authentication/AuthenticationLoading";
import { useErrorBoundary } from "react-error-boundary";
import useAppContext from "../../../explorer/hooks/useAppContext";
import { AppContext } from "../../../explorer/types/System/AppInfo";
import useGoToPage from "../../hook/useGoToPage";
import { useUserInfo } from "../../../explorer/hooks/useUserInfo";

export const AppParamsProvider: React.FC<React.PropsWithChildren> = (
    props: React.PropsWithChildren
) => {
    const languageInitialized = useRef<boolean>(false);
    const contextInitialized = useRef<boolean>(false);
    const brandInitialized = useRef<boolean>(false);
    const initialized = useRef<boolean>(false);
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const lang = searchParams.get("lang");
    const languages = useLanguages().languages;
    const contexts = useAppContext().appContexts;
    const { showBoundary } = useErrorBoundary();
    const goToPage = useGoToPage();
    const [userInfo] = useUserInfo();

    // Recupera tutto quello che trova come path e lo passa a Brand
    let match = useMatch(":context/:brand?/*");
    const pathBrand = match?.params.brand;
    const pathContext = match?.params.context;

    const [navigationState, setNavigationState] =
        useReduxState<NavigationState>(reduxStoreConfig.systemNavigationState);

    // Setta nello stato il brand e il context ogni volta che cambia la location
    React.useEffect(() => {

        if (!contexts || contexts.length === 0) {
            return;
        }
        if (!(languages && languages.length > 0)) {
            return;
        }    

        if (!lang) {
            const defLang = userInfo.defaultLanguage ??  defaultLanguage;
            searchParams.set("lang", defLang);
            setSearchParams(searchParams);
            return
        }

        const newParams: NavigationState = { ...navigationState };
        if (languages.map((la) => la.code).includes(lang)) {
            newParams.lang = lang;
            languageInitialized.current = true;
        } else {
            searchParams.set("lang", defaultLanguage);
            setSearchParams(searchParams);
            return;
        }

        // il context deve essere tra quelli validi
        const validContext: AppContext | undefined = contexts.find(c => c.code.toLocaleLowerCase() === pathContext?.toLocaleLowerCase()) ?? contexts[0];
        newParams.context = validContext?.code ?? contexts[0].code ?? defaultContext;
        contextInitialized.current = true;

        // il brand deve essere tra quelli validi
        const validBrand = validContext?.brands.find(b => b.code?.toLocaleLowerCase() === pathBrand?.toLocaleLowerCase()) ?? validContext?.brands[0];
        newParams.brand = validBrand?.code ?? validContext?.brands[0]?.code ?? defaultBrand;
        brandInitialized.current = true;

        setNavigationState(newParams);
        
        // se il contesto e' valido ma il brand non lo e' allora vado alla home
        if (
          validContext.code.toLocaleLowerCase() ===
            pathContext?.toLocaleLowerCase() &&
          (!pathBrand ||
            pathBrand.toLocaleLowerCase() !==
              newParams.brand.toLocaleLowerCase())
        ) {
          goToPage.goToHome();
        }
        
    }, [location, contexts, lang, languages]);

    // React.useEffect(() => {
    //     setLang();
    // }, [lang, languages]);

    React.useEffect(() => {
        setLang();
        setTimeout(() => {
            if (!initialized.current) {
                initialized.current = true;
                showBoundary("Error initializing user configuration");
            }
        }, 10000);
    }, []);

    // setta la lingua nello stato
    const setLang = () => {
        // const newParams: NavigationState = { ...navigationState };
        // if (lang && languages && languages.length > 0) {
        //     if (languages.map((la) => la.code).includes(lang)) {
        //         newParams.lang = lang;
        //         setNavigationState(newParams);
        //         languageInitialized.current = true;
        //     } else {
        //         searchParams.set("lang", defaultLanguage);
        //         setSearchParams(searchParams);
        //     }
        // }
    };

    initialized.current = languageInitialized.current && contextInitialized.current && brandInitialized.current;    

    if (initialized.current) {
        return <>{props.children}</>;
    } else {
        return (
            <>
                <AuthenticationLoading />
            </>
        );
    }
};
